import React, { useState, useRef, useEffect, ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlusCircle,
  faMinusCircle,
  faChevronDown,
  faChevronUp
} from '@fortawesome/free-solid-svg-icons'
import '../../styles/Animations/Toggle.scss'

interface ToggleProps {
    openTitle: string
    closeTitle: string
    children: ReactNode
    openCallback?: () => void
    className?: string
    iconVariant?: 'plusMinus' | 'disclosure'
}

const Toggle = ({
  openTitle,
  closeTitle,
  children,
  className,
  openCallback,
  iconVariant = 'plusMinus'
}: ToggleProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)

  const toggle = () => {
    const nextOpenState = !isOpen
    setIsOpen(nextOpenState)
    if (nextOpenState && openCallback) {
      openCallback()
    }
  }

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        contentRef.current.style.height = `${contentRef.current.scrollHeight}px`
        setTimeout(() => {
          if (contentRef.current) {
            contentRef.current.style.height = 'auto'
          }
        }, 300)
      } else {
        contentRef.current.style.height = `${contentRef.current.scrollHeight}px`
        setTimeout(() => {
          if (contentRef.current) {
            contentRef.current.style.height = '0'
          }
        }, 0)
      }
    }
  }, [isOpen])

  let currentIcon
  if (iconVariant === 'disclosure') {
    currentIcon = isOpen ? faChevronUp : faChevronDown
  } else {
    currentIcon = isOpen ? faMinusCircle : faPlusCircle
  }

  const titleText = isOpen ? openTitle : closeTitle

  return (
        <div className={`toggle ${className || ''}`}>
            <button onClick={toggle} className="toggle_button">
                {iconVariant === 'disclosure'
                  ? (
                    <>
                        <span className="toggle_button_text">{titleText}</span>
                        <FontAwesomeIcon icon={currentIcon} className="toggle_icon_svg toggle_icon_svg--after" />
                    </>
                    )
                  : (
                    <>
                        <FontAwesomeIcon icon={currentIcon} className="toggle_icon_svg toggle_icon_svg--before" />
                        <span className="toggle_button_text">{titleText}</span>
                    </>
                    )}
            </button>
            <div
                ref={contentRef}
                className={`content ${isOpen ? 'open' : ''}`}
            >
                {children}
            </div>
        </div>
  )
}

export default Toggle
